export const useDragDrop = (onDrop) => {
  const handleDragStart = (e, dealId) => {
    e.dataTransfer.setData("dealId", dealId);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = async (e, targetStageId) => {
    e.preventDefault();
    const dealId = e.dataTransfer.getData("dealId");

    if (onDrop) {
      await onDrop(dealId, targetStageId);
    }
  };

  return {
    handleDragStart,
    handleDragOver,
    handleDrop,
  };
};
